import { freespinsPopupsFont } from '../../fontStyles';
import BasePopup from './BasePopup';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import SoundManager from 'Engine/soundManager/SoundManager';
import { eSounds } from '../../enums/eSounds';
import EntryPoint from 'Engine/EntryPoint';
import { gsap } from 'gsap/all';
import animationCreator from 'Engine/animations/animationCreator';
import eAnimationTypes from '../../animations/animationTypes';
import eEventTypes from '../../enums/eEventTypes';

export default class ControllerFreespinsStart extends BasePopup {
  constructor(data, displayData) {
    super(data, displayData);
    this.alpha = 0;
    this._idleDuration = 2000;
    this.init();
    this.initAnimation();
  }

  addListeners() {
    super.addListeners();
    GlobalDispatcher.add(eEventTypes.EET_FREESPIN_IN_STATE__START, this.updateFreeSpinsAmount.bind(this));
  }

  onGameResized(data) {
    this.container.anchorDefault();

    if (data.isLandscape) {
      if (this.background) this.background.goToFrame(2);
    } else if (data.isMobile && data.isPortrait) {
      this.container.y -= 200;
      if (this.background) this.background.goToFrame(1);
    }
  }

  init() {
    super.init();
    this.container = this.wrapper.getChildByName('container');
    // this.amount = this.wrapper.getChildByName('amount');
    // this.winningText = this.container.getChildByName('freespins_popup_start_you_win');
    this.freespinsText0 = this.container.getChildByName('freespins_popup_start_freespin_0');
    this.freespinsText1 = this.container.getChildByName('freespins_popup_start_freespin_1');
    // this.winningText.correctPosition('center', 'center');
    this.freespinsText0.correctPosition('center', 'center');
    this.freespinsText1.correctPosition('center', 'center');
    this.setTextStile();
    // this.createMask(this.container);
  }

  initAnimation() {
    // this.animation = animationCreator.createAnimation(eAnimationTypes.BIG_WIN);
    // this.animation.visible = false;
    // this.wrapper.getChildByName('animationPlace').addChild(this.animation);
  }

  setTextStile() {
    // this.amount.style = { ...this.amount.style, ...freespinsPopupsFont };
    // this.winningText.style = { ...this.winningText.style, ...freespinsPopupsFont };
    this.freespinsText0.style = { ...this.freespinsText0.style, ...freespinsPopupsFont };
    this.freespinsText1.style = { ...this.freespinsText1.style, ...freespinsPopupsFont };
  }

  updateFreeSpinsAmount() {
    // this.amount.text = EntryPoint.GameModel.freespins;
  }

  show(delay) {
    this.container.alpha = 0;
    super.show(delay);
  }

  playAnimation() {
    // this.animation.state.setAnimation(0, eAnimationNames.EAN_FREE_SPINS_START__START, false);
    // this.animation.state.addAnimation(0, eAnimationNames.EAN_FREE_SPINS_START__IDLE, true, 0);
    // this.animation.visible = true;
  }

  stopAnimation() {
    // this.animation.visible = false;
    // this.animation.state.clearTrack(0);
    // this.animation.lastTime = null;
  }

  onShowStart() {
    super.onShowStart();
    this.playAnimation();
    // this.startMaskUpdate(this.container);
  }

  onShow() {
    super.onShow();

    gsap.to(this.container, { alpha: 1, duration: 1 });
    this.startIdle();
    SoundManager.play(eSounds.EST_START_FREESPINS.soundName, eSounds.EST_START_FREESPINS.volume, false, eSounds.EST_START_FREESPINS.group);
    GlobalDispatcher.dispatch(eEventTypes.EET_FREESPINS_START__SHOWN_UP);
  }

  hide() {
    super.hide();
    GlobalDispatcher.dispatch(eEventTypes.EET_SHOW_USER_INTERFACE);
  }

  onHide() {
    super.onHide();
    this.stopAnimation();
    const freespinsSound = SoundManager.getSound(eSounds.EST_START_FREESPINS.soundName);
    const tween = gsap.timeline();
    tween
      .to(freespinsSound, { volume: 0, duration: 0.5 })
      .call(() => {
        SoundManager.pause(eSounds.EST_START_FREESPINS.soundName);
      }).call(() => {
      GlobalDispatcher.dispatch(eEventTypes.EET_FREESPINS_START__ON_COMPLETE);
    }, [], '+=0.5');
  }

  playMainBackgroundSound() {
    const sound = SoundManager.play(eSounds.EST_BACKGROUND_BONUS.soundName, eSounds.EST_BACKGROUND_BONUS.volume, true, eSounds.EST_BACKGROUND_BONUS.group);
    gsap.fromTo(sound, { volume: 0 }, { volume: 0.7, duration: 1.5 })
  }
}
